import { Avatar, Tooltip } from '@fluentui/react-components';
import { PersonRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useProfileAvatarStyles } from './ProfileAvatar.styles';

export interface ProfileAvatarProps {
  displayName?: string | undefined;
  photoUrl?: string | undefined;
  onClick?: (() => void) | undefined;
}

export function ProfileAvatar({
  displayName,
  photoUrl,
  onClick,
}: ProfileAvatarProps): React.JSX.Element {
  const styles = useProfileAvatarStyles();
  const { t } = useTranslation();

  const hasName = displayName != null && displayName.trim().length > 0;
  const tooltipContent = hasName ? displayName : t('header.profile');

  return (
    <Tooltip content={tooltipContent} relationship="description">
      <div
        className={styles.root}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
          }
        }}
      >
        {hasName ? (
          <Avatar
            name={displayName}
            aria-label={displayName}
            image={photoUrl ? { src: photoUrl } : undefined}
            size={28}
            color="colorful"
          />
        ) : (
          <Avatar aria-label={tooltipContent} icon={<PersonRegular />} size={28} />
        )}
      </div>
    </Tooltip>
  );
}
